'use strict';

var $ = require('jquery');

var classNames = {
	userReviewForm: 'user-review-form',
	reviewDetailsPanel: 'panel--review-details',
	userDetailsPanel: 'panel--user-details'
};

function displayUserDetailPanel() {
	var $form = $.findByBem(classNames.userReviewForm);

	if ($form.length > 0) {
		var $reviewDetails = $form.findByBem(classNames.userReviewForm, classNames.reviewDetailsPanel);
		$reviewDetails.animate({left: -($form.innerWidth() + 1)});
	}
}

function displayInvalidPanel() {
	var $form = $.findByBem(classNames.userReviewForm);

	if ($form.length > 0) {
		var $reviewDetails = $form.findByBem(classNames.userReviewForm, classNames.reviewDetailsPanel);
		var $errors = $reviewDetails.find('[data-invalid]');

		if ($errors.length > 0) {
			$reviewDetails.animate({left: 0});
		}
	}
}

function displayResultPanel() {
	var $form = $.findByBem(classNames.userReviewForm);

	if ($form.length > 0) {
		var $userDetails = $form.findByBem(classNames.userReviewForm, classNames.userDetailsPanel);
		var $reviewDetails = $form.findByBem(classNames.userReviewForm, classNames.reviewDetailsPanel);
		
		$userDetails.animate({
			left: -($form.innerWidth() + 1)
		}, function () {
			$userDetails.hide();
			$reviewDetails.hide();
		});
	}
}

function handleUserReviewSubmit() {
	var $form = $.findByBem(classNames.userReviewForm);

	if ($form.length > 0) {
		var data = $form.serialize();

		var $button 		= $form.findByBem(classNames.userReviewForm, 'button');
		var $successMessage = $form.findByBem(classNames.userReviewForm, 'success');
		var $failureMessage = $form.findByBem(classNames.userReviewForm, 'failure');

		$.ajax({
			url: $form[0].action,
			type: $form[0].method,
			data: data,
			beforeSend: function () {
				$button.attr('disabled', 'disabled');
				$button.addBemClass(classNames.userReviewForm, 'button', 'loading');
				$button.data('orig-html', $button.html());
				$button.html('Please wait...');
			},
			success: function () {
				$successMessage.show();
				$failureMessage.hide();
				$form.findByBem(classNames.userReviewForm, 'entry').find('input,select,textarea').val('');
			},
			error: function () {
				$successMessage.hide();
				$failureMessage.show();
			},
			complete: function () {
				$button.html($button.data('orig-html'));
				$button.removeBemClass(classNames.userReviewForm, 'button', 'loading');
				$button.removeAttr('disabled');
				displayResultPanel();
			}
		});
	}
}

module.exports = {
	init: function () {
		var $form = $.findByBem(classNames.userReviewForm);
		var $nextButton = $form.findByBem(classNames.userReviewForm, 'button--next');
		
		$form.on('valid.fndtn.abide', handleUserReviewSubmit);
		$form.on('invalid.fndtn.abide', displayInvalidPanel);
		$nextButton.on('click.user-review-form.next', displayUserDetailPanel);
	}
};